import {
  PayeeRequirement,
  PayerEngagement
} from "@wingspanhq/wingspan-api-sdk";

/**
 * The requirement instances attached to one assignment.
 *
 * v1's `IPayerEngagementResponse` carried its requirements inline; the v3
 * `PayerEngagement` is lean and carries none, so the screen reads the
 * requirement list once and each engagement matches itself against it on
 * `payeeEngagementIds`.
 */
export const selectorPayerEngagementRequirements = ({
  engagement,
  requirements
}: {
  engagement: PayerEngagement;
  requirements: PayeeRequirement[];
}): PayeeRequirement[] =>
  requirements.filter(requirement =>
    requirement.payeeEngagementIds?.includes(engagement.id as string)
  );
